export default __webpack_public_path__ + "static/media/modal_filter_icon.0afa3e27.svg";